/**
 * Stripe's success URL is the redirect URL with `unlocked=true` appended (see
 * `createCheckoutLink` in packages/payments/provider/stripe). The parameter
 * says the visitor came back from a completed checkout, not that the webhook
 * has unlocked the report yet.
 */
const CHECKOUT_RETURN_PARAM = "unlocked";

/** Whether a location search string marks a return from Stripe checkout. */
export function isCheckoutReturn(search: string): boolean {
	return new URLSearchParams(search).get(CHECKOUT_RETURN_PARAM) === "true";
}

/** `href` without the checkout-return parameter, keeping everything else. */
export function withoutCheckoutReturnParam(href: string): string {
	const url = new URL(href);
	url.searchParams.delete(CHECKOUT_RETURN_PARAM);
	return url.toString();
}
